/* eslint-disable */
// GENERATED by scripts/icons/generate-phosphor-registry.mjs -- do not edit by hand.
// One ?raw import per Phosphor Regular icon named in mdiMap.ts, tablerMap.ts
// and DsIcon.ts, so only the glyphs the app uses end up in the bundle.
import ph_ambulance from '@phosphor-icons/core/assets/regular/ambulance.svg?raw';
import ph_angle from '@phosphor-icons/core/assets/regular/angle.svg?raw';
import ph_aperture from '@phosphor-icons/core/assets/regular/aperture.svg?raw';
import ph_archive from '@phosphor-icons/core/assets/regular/archive.svg?raw';
import ph_arrow_bend_up_left from '@phosphor-icons/core/assets/regular/arrow-bend-up-left.svg?raw';
import ph_arrow_circle_right from '@phosphor-icons/core/assets/regular/arrow-circle-right.svg?raw';
import ph_arrow_circle_up from '@phosphor-icons/core/assets/regular/arrow-circle-up.svg?raw';
import ph_arrow_clockwise from '@phosphor-icons/core/assets/regular/arrow-clockwise.svg?raw';
import ph_arrow_counter_clockwise from '@phosphor-icons/core/assets/regular/arrow-counter-clockwise.svg?raw';
import ph_arrow_down from '@phosphor-icons/core/assets/regular/arrow-down.svg?raw';
import ph_arrow_down_right from '@phosphor-icons/core/assets/regular/arrow-down-right.svg?raw';
import ph_arrow_elbow_down_right from '@phosphor-icons/core/assets/regular/arrow-elbow-down-right.svg?raw';
import ph_arrow_fat_up from '@phosphor-icons/core/assets/regular/arrow-fat-up.svg?raw';
import ph_arrow_left from '@phosphor-icons/core/assets/regular/arrow-left.svg?raw';
import ph_arrow_right from '@phosphor-icons/core/assets/regular/arrow-right.svg?raw';
import ph_arrow_square_in from '@phosphor-icons/core/assets/regular/arrow-square-in.svg?raw';
import ph_arrow_square_left from '@phosphor-icons/core/assets/regular/arrow-square-left.svg?raw';
import ph_arrow_square_out from '@phosphor-icons/core/assets/regular/arrow-square-out.svg?raw';
import ph_arrow_square_right from '@phosphor-icons/core/assets/regular/arrow-square-right.svg?raw';
import ph_arrow_u_up_left from '@phosphor-icons/core/assets/regular/arrow-u-up-left.svg?raw';
import ph_arrow_u_up_right from '@phosphor-icons/core/assets/regular/arrow-u-up-right.svg?raw';
import ph_arrow_up from '@phosphor-icons/core/assets/regular/arrow-up.svg?raw';
import ph_arrow_up_left from '@phosphor-icons/core/assets/regular/arrow-up-left.svg?raw';
import ph_arrow_up_right from '@phosphor-icons/core/assets/regular/arrow-up-right.svg?raw';
import ph_arrows_clockwise from '@phosphor-icons/core/assets/regular/arrows-clockwise.svg?raw';
import ph_arrows_down_up from '@phosphor-icons/core/assets/regular/arrows-down-up.svg?raw';
import ph_arrows_in from '@phosphor-icons/core/assets/regular/arrows-in.svg?raw';
import ph_arrows_in_line_horizontal from '@phosphor-icons/core/assets/regular/arrows-in-line-horizontal.svg?raw';
import ph_arrows_left_right from '@phosphor-icons/core/assets/regular/arrows-left-right.svg?raw';
import ph_arrows_out from '@phosphor-icons/core/assets/regular/arrows-out.svg?raw';
import ph_arrows_out_cardinal from '@phosphor-icons/core/assets/regular/arrows-out-cardinal.svg?raw';
import ph_arrows_out_line_horizontal from '@phosphor-icons/core/assets/regular/arrows-out-line-horizontal.svg?raw';
import ph_arrows_out_line_vertical from '@phosphor-icons/core/assets/regular/arrows-out-line-vertical.svg?raw';
import ph_arrows_split from '@phosphor-icons/core/assets/regular/arrows-split.svg?raw';
import ph_article from '@phosphor-icons/core/assets/regular/article.svg?raw';
import ph_baby_carriage from '@phosphor-icons/core/assets/regular/baby-carriage.svg?raw';
import ph_barricade from '@phosphor-icons/core/assets/regular/barricade.svg?raw';
import ph_basket from '@phosphor-icons/core/assets/regular/basket.svg?raw';
import ph_bathtub from '@phosphor-icons/core/assets/regular/bathtub.svg?raw';
import ph_bed from '@phosphor-icons/core/assets/regular/bed.svg?raw';
import ph_bell from '@phosphor-icons/core/assets/regular/bell.svg?raw';
import ph_bell_ringing from '@phosphor-icons/core/assets/regular/bell-ringing.svg?raw';
import ph_bell_slash from '@phosphor-icons/core/assets/regular/bell-slash.svg?raw';
import ph_bezier_curve from '@phosphor-icons/core/assets/regular/bezier-curve.svg?raw';
import ph_blueprint from '@phosphor-icons/core/assets/regular/blueprint.svg?raw';
import ph_bluetooth from '@phosphor-icons/core/assets/regular/bluetooth.svg?raw';
import ph_book from '@phosphor-icons/core/assets/regular/book.svg?raw';
import ph_book_open from '@phosphor-icons/core/assets/regular/book-open.svg?raw';
import ph_book_open_text from '@phosphor-icons/core/assets/regular/book-open-text.svg?raw';
import ph_bookmark_simple from '@phosphor-icons/core/assets/regular/bookmark-simple.svg?raw';
import ph_books from '@phosphor-icons/core/assets/regular/books.svg?raw';
import ph_bounding_box from '@phosphor-icons/core/assets/regular/bounding-box.svg?raw';
import ph_brackets_curly from '@phosphor-icons/core/assets/regular/brackets-curly.svg?raw';
import ph_brain from '@phosphor-icons/core/assets/regular/brain.svg?raw';
import ph_bridge from '@phosphor-icons/core/assets/regular/bridge.svg?raw';
import ph_briefcase from '@phosphor-icons/core/assets/regular/briefcase.svg?raw';
import ph_broom from '@phosphor-icons/core/assets/regular/broom.svg?raw';
import ph_browser from '@phosphor-icons/core/assets/regular/browser.svg?raw';
import ph_building from '@phosphor-icons/core/assets/regular/building.svg?raw';
import ph_building_office from '@phosphor-icons/core/assets/regular/building-office.svg?raw';
import ph_buildings from '@phosphor-icons/core/assets/regular/buildings.svg?raw';
import ph_bulldozer from '@phosphor-icons/core/assets/regular/bulldozer.svg?raw';
import ph_calculator from '@phosphor-icons/core/assets/regular/calculator.svg?raw';
import ph_calendar from '@phosphor-icons/core/assets/regular/calendar.svg?raw';
import ph_calendar_blank from '@phosphor-icons/core/assets/regular/calendar-blank.svg?raw';
import ph_calendar_check from '@phosphor-icons/core/assets/regular/calendar-check.svg?raw';
import ph_calendar_dot from '@phosphor-icons/core/assets/regular/calendar-dot.svg?raw';
import ph_calendar_dots from '@phosphor-icons/core/assets/regular/calendar-dots.svg?raw';
import ph_calendar_plus from '@phosphor-icons/core/assets/regular/calendar-plus.svg?raw';
import ph_calendar_slash from '@phosphor-icons/core/assets/regular/calendar-slash.svg?raw';
import ph_calendar_star from '@phosphor-icons/core/assets/regular/calendar-star.svg?raw';
import ph_calendar_x from '@phosphor-icons/core/assets/regular/calendar-x.svg?raw';
import ph_camera from '@phosphor-icons/core/assets/regular/camera.svg?raw';
import ph_camera_plus from '@phosphor-icons/core/assets/regular/camera-plus.svg?raw';
import ph_cards from '@phosphor-icons/core/assets/regular/cards.svg?raw';
import ph_caret_circle_down from '@phosphor-icons/core/assets/regular/caret-circle-down.svg?raw';
import ph_caret_double_left from '@phosphor-icons/core/assets/regular/caret-double-left.svg?raw';
import ph_caret_double_right from '@phosphor-icons/core/assets/regular/caret-double-right.svg?raw';
import ph_caret_down from '@phosphor-icons/core/assets/regular/caret-down.svg?raw';
import ph_caret_left from '@phosphor-icons/core/assets/regular/caret-left.svg?raw';
import ph_caret_line_left from '@phosphor-icons/core/assets/regular/caret-line-left.svg?raw';
import ph_caret_line_right from '@phosphor-icons/core/assets/regular/caret-line-right.svg?raw';
import ph_caret_right from '@phosphor-icons/core/assets/regular/caret-right.svg?raw';
import ph_caret_up from '@phosphor-icons/core/assets/regular/caret-up.svg?raw';
import ph_caret_up_down from '@phosphor-icons/core/assets/regular/caret-up-down.svg?raw';
import ph_certificate from '@phosphor-icons/core/assets/regular/certificate.svg?raw';
import ph_chart_bar from '@phosphor-icons/core/assets/regular/chart-bar.svg?raw';
import ph_chart_bar_horizontal from '@phosphor-icons/core/assets/regular/chart-bar-horizontal.svg?raw';
import ph_chart_line from '@phosphor-icons/core/assets/regular/chart-line.svg?raw';
import ph_chart_line_down from '@phosphor-icons/core/assets/regular/chart-line-down.svg?raw';
import ph_chart_line_up from '@phosphor-icons/core/assets/regular/chart-line-up.svg?raw';
import ph_chart_pie from '@phosphor-icons/core/assets/regular/chart-pie.svg?raw';
import ph_chart_scatter from '@phosphor-icons/core/assets/regular/chart-scatter.svg?raw';
import ph_chat from '@phosphor-icons/core/assets/regular/chat.svg?raw';
import ph_chat_circle from '@phosphor-icons/core/assets/regular/chat-circle.svg?raw';
import ph_chat_circle_dots from '@phosphor-icons/core/assets/regular/chat-circle-dots.svg?raw';
import ph_chat_circle_text from '@phosphor-icons/core/assets/regular/chat-circle-text.svg?raw';
import ph_chat_dots from '@phosphor-icons/core/assets/regular/chat-dots.svg?raw';
import ph_chat_teardrop from '@phosphor-icons/core/assets/regular/chat-teardrop.svg?raw';
import ph_chat_text from '@phosphor-icons/core/assets/regular/chat-text.svg?raw';
import ph_chats from '@phosphor-icons/core/assets/regular/chats.svg?raw';
import ph_chats_circle from '@phosphor-icons/core/assets/regular/chats-circle.svg?raw';
import ph_check from '@phosphor-icons/core/assets/regular/check.svg?raw';
import ph_check_circle from '@phosphor-icons/core/assets/regular/check-circle.svg?raw';
import ph_check_square from '@phosphor-icons/core/assets/regular/check-square.svg?raw';
import ph_check_square_offset from '@phosphor-icons/core/assets/regular/check-square-offset.svg?raw';
import ph_checkerboard from '@phosphor-icons/core/assets/regular/checkerboard.svg?raw';
import ph_checks from '@phosphor-icons/core/assets/regular/checks.svg?raw';
import ph_circle from '@phosphor-icons/core/assets/regular/circle.svg?raw';
import ph_circle_dashed from '@phosphor-icons/core/assets/regular/circle-dashed.svg?raw';
import ph_circle_half from '@phosphor-icons/core/assets/regular/circle-half.svg?raw';
import ph_circle_notch from '@phosphor-icons/core/assets/regular/circle-notch.svg?raw';
import ph_circles_three from '@phosphor-icons/core/assets/regular/circles-three.svg?raw';
import ph_city from '@phosphor-icons/core/assets/regular/city.svg?raw';
import ph_clipboard from '@phosphor-icons/core/assets/regular/clipboard.svg?raw';
import ph_clipboard_text from '@phosphor-icons/core/assets/regular/clipboard-text.svg?raw';
import ph_clock from '@phosphor-icons/core/assets/regular/clock.svg?raw';
import ph_clock_clockwise from '@phosphor-icons/core/assets/regular/clock-clockwise.svg?raw';
import ph_clock_countdown from '@phosphor-icons/core/assets/regular/clock-countdown.svg?raw';
import ph_clock_counter_clockwise from '@phosphor-icons/core/assets/regular/clock-counter-clockwise.svg?raw';
import ph_clock_user from '@phosphor-icons/core/assets/regular/clock-user.svg?raw';
import ph_cloud from '@phosphor-icons/core/assets/regular/cloud.svg?raw';
import ph_cloud_arrow_down from '@phosphor-icons/core/assets/regular/cloud-arrow-down.svg?raw';
import ph_cloud_arrow_up from '@phosphor-icons/core/assets/regular/cloud-arrow-up.svg?raw';
import ph_cloud_check from '@phosphor-icons/core/assets/regular/cloud-check.svg?raw';
import ph_cloud_fog from '@phosphor-icons/core/assets/regular/cloud-fog.svg?raw';
import ph_cloud_lightning from '@phosphor-icons/core/assets/regular/cloud-lightning.svg?raw';
import ph_cloud_rain from '@phosphor-icons/core/assets/regular/cloud-rain.svg?raw';
import ph_cloud_slash from '@phosphor-icons/core/assets/regular/cloud-slash.svg?raw';
import ph_cloud_snow from '@phosphor-icons/core/assets/regular/cloud-snow.svg?raw';
import ph_cloud_sun from '@phosphor-icons/core/assets/regular/cloud-sun.svg?raw';
import ph_cloud_warning from '@phosphor-icons/core/assets/regular/cloud-warning.svg?raw';
import ph_coat_hanger from '@phosphor-icons/core/assets/regular/coat-hanger.svg?raw';
import ph_code from '@phosphor-icons/core/assets/regular/code.svg?raw';
import ph_coins from '@phosphor-icons/core/assets/regular/coins.svg?raw';
import ph_columns from '@phosphor-icons/core/assets/regular/columns.svg?raw';
import ph_columns_plus_right from '@phosphor-icons/core/assets/regular/columns-plus-right.svg?raw';
import ph_compass from '@phosphor-icons/core/assets/regular/compass.svg?raw';
import ph_compass_tool from '@phosphor-icons/core/assets/regular/compass-tool.svg?raw';
import ph_copy from '@phosphor-icons/core/assets/regular/copy.svg?raw';
import ph_copy_simple from '@phosphor-icons/core/assets/regular/copy-simple.svg?raw';
import ph_corners_in from '@phosphor-icons/core/assets/regular/corners-in.svg?raw';
import ph_corners_out from '@phosphor-icons/core/assets/regular/corners-out.svg?raw';
import ph_couch from '@phosphor-icons/core/assets/regular/couch.svg?raw';
import ph_credit_card from '@phosphor-icons/core/assets/regular/credit-card.svg?raw';
import ph_cross from '@phosphor-icons/core/assets/regular/cross.svg?raw';
import ph_crown from '@phosphor-icons/core/assets/regular/crown.svg?raw';
import ph_cube from '@phosphor-icons/core/assets/regular/cube.svg?raw';
import ph_currency_dollar from '@phosphor-icons/core/assets/regular/currency-dollar.svg?raw';
import ph_cursor from '@phosphor-icons/core/assets/regular/cursor.svg?raw';
import ph_database from '@phosphor-icons/core/assets/regular/database.svg?raw';
import ph_desk from '@phosphor-icons/core/assets/regular/desk.svg?raw';
import ph_device_mobile from '@phosphor-icons/core/assets/regular/device-mobile.svg?raw';
import ph_diamond from '@phosphor-icons/core/assets/regular/diamond.svg?raw';
import ph_door from '@phosphor-icons/core/assets/regular/door.svg?raw';
import ph_door_open from '@phosphor-icons/core/assets/regular/door-open.svg?raw';
import ph_dots_nine from '@phosphor-icons/core/assets/regular/dots-nine.svg?raw';
import ph_dots_six from '@phosphor-icons/core/assets/regular/dots-six.svg?raw';
import ph_dots_six_vertical from '@phosphor-icons/core/assets/regular/dots-six-vertical.svg?raw';
import ph_dots_three from '@phosphor-icons/core/assets/regular/dots-three.svg?raw';
import ph_dots_three_vertical from '@phosphor-icons/core/assets/regular/dots-three-vertical.svg?raw';
import ph_download_simple from '@phosphor-icons/core/assets/regular/download-simple.svg?raw';
import ph_dresser from '@phosphor-icons/core/assets/regular/dresser.svg?raw';
import ph_drop from '@phosphor-icons/core/assets/regular/drop.svg?raw';
import ph_drop_half from '@phosphor-icons/core/assets/regular/drop-half.svg?raw';
import ph_drop_slash from '@phosphor-icons/core/assets/regular/drop-slash.svg?raw';
import ph_dropbox_logo from '@phosphor-icons/core/assets/regular/dropbox-logo.svg?raw';
import ph_envelope_simple from '@phosphor-icons/core/assets/regular/envelope-simple.svg?raw';
import ph_envelope_simple_open from '@phosphor-icons/core/assets/regular/envelope-simple-open.svg?raw';
import ph_equals from '@phosphor-icons/core/assets/regular/equals.svg?raw';
import ph_eraser from '@phosphor-icons/core/assets/regular/eraser.svg?raw';
import ph_exclamation_mark from '@phosphor-icons/core/assets/regular/exclamation-mark.svg?raw';
import ph_export from '@phosphor-icons/core/assets/regular/export.svg?raw';
import ph_eye from '@phosphor-icons/core/assets/regular/eye.svg?raw';
import ph_eye_slash from '@phosphor-icons/core/assets/regular/eye-slash.svg?raw';
import ph_eyedropper from '@phosphor-icons/core/assets/regular/eyedropper.svg?raw';
import ph_facebook_logo from '@phosphor-icons/core/assets/regular/facebook-logo.svg?raw';
import ph_fan from '@phosphor-icons/core/assets/regular/fan.svg?raw';
import ph_file from '@phosphor-icons/core/assets/regular/file.svg?raw';
import ph_file_arrow_down from '@phosphor-icons/core/assets/regular/file-arrow-down.svg?raw';
import ph_file_arrow_up from '@phosphor-icons/core/assets/regular/file-arrow-up.svg?raw';
import ph_file_code from '@phosphor-icons/core/assets/regular/file-code.svg?raw';
import ph_file_csv from '@phosphor-icons/core/assets/regular/file-csv.svg?raw';
import ph_file_dashed from '@phosphor-icons/core/assets/regular/file-dashed.svg?raw';
import ph_file_doc from '@phosphor-icons/core/assets/regular/file-doc.svg?raw';
import ph_file_image from '@phosphor-icons/core/assets/regular/file-image.svg?raw';
import ph_file_magnifying_glass from '@phosphor-icons/core/assets/regular/file-magnifying-glass.svg?raw';
import ph_file_pdf from '@phosphor-icons/core/assets/regular/file-pdf.svg?raw';
import ph_file_plus from '@phosphor-icons/core/assets/regular/file-plus.svg?raw';
import ph_file_ppt from '@phosphor-icons/core/assets/regular/file-ppt.svg?raw';
import ph_file_text from '@phosphor-icons/core/assets/regular/file-text.svg?raw';
import ph_file_xls from '@phosphor-icons/core/assets/regular/file-xls.svg?raw';
import ph_file_zip from '@phosphor-icons/core/assets/regular/file-zip.svg?raw';
import ph_files from '@phosphor-icons/core/assets/regular/files.svg?raw';
import ph_film_strip from '@phosphor-icons/core/assets/regular/film-strip.svg?raw';
import ph_fire_extinguisher from '@phosphor-icons/core/assets/regular/fire-extinguisher.svg?raw';
import ph_first_aid_kit from '@phosphor-icons/core/assets/regular/first-aid-kit.svg?raw';
import ph_flag from '@phosphor-icons/core/assets/regular/flag.svg?raw';
import ph_flag_checkered from '@phosphor-icons/core/assets/regular/flag-checkered.svg?raw';
import ph_flame from '@phosphor-icons/core/assets/regular/flame.svg?raw';
import ph_flask from '@phosphor-icons/core/assets/regular/flask.svg?raw';
import ph_flip_horizontal from '@phosphor-icons/core/assets/regular/flip-horizontal.svg?raw';
import ph_flip_vertical from '@phosphor-icons/core/assets/regular/flip-vertical.svg?raw';
import ph_floppy_disk from '@phosphor-icons/core/assets/regular/floppy-disk.svg?raw';
import ph_flower from '@phosphor-icons/core/assets/regular/flower.svg?raw';
import ph_folder from '@phosphor-icons/core/assets/regular/folder.svg?raw';
import ph_folder_open from '@phosphor-icons/core/assets/regular/folder-open.svg?raw';
import ph_folder_plus from '@phosphor-icons/core/assets/regular/folder-plus.svg?raw';
import ph_folder_simple_dashed from '@phosphor-icons/core/assets/regular/folder-simple-dashed.svg?raw';
import ph_folders from '@phosphor-icons/core/assets/regular/folders.svg?raw';
import ph_fork_knife from '@phosphor-icons/core/assets/regular/fork-knife.svg?raw';
import ph_frame_corners from '@phosphor-icons/core/assets/regular/frame-corners.svg?raw';
import ph_function from '@phosphor-icons/core/assets/regular/function.svg?raw';
import ph_funnel from '@phosphor-icons/core/assets/regular/funnel.svg?raw';
import ph_funnel_simple from '@phosphor-icons/core/assets/regular/funnel-simple.svg?raw';
import ph_funnel_x from '@phosphor-icons/core/assets/regular/funnel-x.svg?raw';
import ph_garage from '@phosphor-icons/core/assets/regular/garage.svg?raw';
import ph_gauge from '@phosphor-icons/core/assets/regular/gauge.svg?raw';
import ph_gear from '@phosphor-icons/core/assets/regular/gear.svg?raw';
import ph_gift from '@phosphor-icons/core/assets/regular/gift.svg?raw';
import ph_git_branch from '@phosphor-icons/core/assets/regular/git-branch.svg?raw';
import ph_github_logo from '@phosphor-icons/core/assets/regular/github-logo.svg?raw';
import ph_globe from '@phosphor-icons/core/assets/regular/globe.svg?raw';
import ph_google_drive_logo from '@phosphor-icons/core/assets/regular/google-drive-logo.svg?raw';
import ph_grid_four from '@phosphor-icons/core/assets/regular/grid-four.svg?raw';
import ph_hammer from '@phosphor-icons/core/assets/regular/hammer.svg?raw';
import ph_hand from '@phosphor-icons/core/assets/regular/hand.svg?raw';
import ph_hand_coins from '@phosphor-icons/core/assets/regular/hand-coins.svg?raw';
import ph_hand_heart from '@phosphor-icons/core/assets/regular/hand-heart.svg?raw';
import ph_hand_swipe_left from '@phosphor-icons/core/assets/regular/hand-swipe-left.svg?raw';
import ph_hand_tap from '@phosphor-icons/core/assets/regular/hand-tap.svg?raw';
import ph_hard_hat from '@phosphor-icons/core/assets/regular/hard-hat.svg?raw';
import ph_hash from '@phosphor-icons/core/assets/regular/hash.svg?raw';
import ph_heart from '@phosphor-icons/core/assets/regular/heart.svg?raw';
import ph_heart_half from '@phosphor-icons/core/assets/regular/heart-half.svg?raw';
import ph_heartbeat from '@phosphor-icons/core/assets/regular/heartbeat.svg?raw';
import ph_highlighter from '@phosphor-icons/core/assets/regular/highlighter.svg?raw';
import ph_hourglass from '@phosphor-icons/core/assets/regular/hourglass.svg?raw';
import ph_hourglass_medium from '@phosphor-icons/core/assets/regular/hourglass-medium.svg?raw';
import ph_house from '@phosphor-icons/core/assets/regular/house.svg?raw';
import ph_house_line from '@phosphor-icons/core/assets/regular/house-line.svg?raw';
import ph_house_simple from '@phosphor-icons/core/assets/regular/house-simple.svg?raw';
import ph_identification_badge from '@phosphor-icons/core/assets/regular/identification-badge.svg?raw';
import ph_image from '@phosphor-icons/core/assets/regular/image.svg?raw';
import ph_image_broken from '@phosphor-icons/core/assets/regular/image-broken.svg?raw';
import ph_images from '@phosphor-icons/core/assets/regular/images.svg?raw';
import ph_infinity from '@phosphor-icons/core/assets/regular/infinity.svg?raw';
import ph_info from '@phosphor-icons/core/assets/regular/info.svg?raw';
import ph_instagram_logo from '@phosphor-icons/core/assets/regular/instagram-logo.svg?raw';
import ph_intersect_square from '@phosphor-icons/core/assets/regular/intersect-square.svg?raw';
import ph_invoice from '@phosphor-icons/core/assets/regular/invoice.svg?raw';
import ph_key from '@phosphor-icons/core/assets/regular/key.svg?raw';
import ph_keyboard from '@phosphor-icons/core/assets/regular/keyboard.svg?raw';
import ph_ladder from '@phosphor-icons/core/assets/regular/ladder.svg?raw';
import ph_laptop from '@phosphor-icons/core/assets/regular/laptop.svg?raw';
import ph_layout from '@phosphor-icons/core/assets/regular/layout.svg?raw';
import ph_lifebuoy from '@phosphor-icons/core/assets/regular/lifebuoy.svg?raw';
import ph_lightbulb from '@phosphor-icons/core/assets/regular/lightbulb.svg?raw';
import ph_lightbulb_filament from '@phosphor-icons/core/assets/regular/lightbulb-filament.svg?raw';
import ph_lightning from '@phosphor-icons/core/assets/regular/lightning.svg?raw';
import ph_line_segment from '@phosphor-icons/core/assets/regular/line-segment.svg?raw';
import ph_line_segments from '@phosphor-icons/core/assets/regular/line-segments.svg?raw';
import ph_line_vertical from '@phosphor-icons/core/assets/regular/line-vertical.svg?raw';
import ph_link from '@phosphor-icons/core/assets/regular/link.svg?raw';
import ph_link_break from '@phosphor-icons/core/assets/regular/link-break.svg?raw';
import ph_link_simple from '@phosphor-icons/core/assets/regular/link-simple.svg?raw';
import ph_link_simple_break from '@phosphor-icons/core/assets/regular/link-simple-break.svg?raw';
import ph_linkedin_logo from '@phosphor-icons/core/assets/regular/linkedin-logo.svg?raw';
import ph_list from '@phosphor-icons/core/assets/regular/list.svg?raw';
import ph_list_bullets from '@phosphor-icons/core/assets/regular/list-bullets.svg?raw';
import ph_list_checks from '@phosphor-icons/core/assets/regular/list-checks.svg?raw';
import ph_list_dashes from '@phosphor-icons/core/assets/regular/list-dashes.svg?raw';
import ph_list_magnifying_glass from '@phosphor-icons/core/assets/regular/list-magnifying-glass.svg?raw';
import ph_list_numbers from '@phosphor-icons/core/assets/regular/list-numbers.svg?raw';
import ph_list_plus from '@phosphor-icons/core/assets/regular/list-plus.svg?raw';
import ph_lock from '@phosphor-icons/core/assets/regular/lock.svg?raw';
import ph_lock_open from '@phosphor-icons/core/assets/regular/lock-open.svg?raw';
import ph_lock_simple from '@phosphor-icons/core/assets/regular/lock-simple.svg?raw';
import ph_magic_wand from '@phosphor-icons/core/assets/regular/magic-wand.svg?raw';
import ph_magnet from '@phosphor-icons/core/assets/regular/magnet.svg?raw';
import ph_magnet_straight from '@phosphor-icons/core/assets/regular/magnet-straight.svg?raw';
import ph_magnifying_glass from '@phosphor-icons/core/assets/regular/magnifying-glass.svg?raw';
import ph_magnifying_glass_minus from '@phosphor-icons/core/assets/regular/magnifying-glass-minus.svg?raw';
import ph_magnifying_glass_plus from '@phosphor-icons/core/assets/regular/magnifying-glass-plus.svg?raw';
import ph_map_pin from '@phosphor-icons/core/assets/regular/map-pin.svg?raw';
import ph_map_pin_area from '@phosphor-icons/core/assets/regular/map-pin-area.svg?raw';
import ph_map_trifold from '@phosphor-icons/core/assets/regular/map-trifold.svg?raw';
import ph_megaphone from '@phosphor-icons/core/assets/regular/megaphone.svg?raw';
import ph_megaphone_simple from '@phosphor-icons/core/assets/regular/megaphone-simple.svg?raw';
import ph_microphone from '@phosphor-icons/core/assets/regular/microphone.svg?raw';
import ph_microphone_slash from '@phosphor-icons/core/assets/regular/microphone-slash.svg?raw';
import ph_minus from '@phosphor-icons/core/assets/regular/minus.svg?raw';
import ph_minus_circle from '@phosphor-icons/core/assets/regular/minus-circle.svg?raw';
import ph_minus_square from '@phosphor-icons/core/assets/regular/minus-square.svg?raw';
import ph_money from '@phosphor-icons/core/assets/regular/money.svg?raw';
import ph_money_wavy from '@phosphor-icons/core/assets/regular/money-wavy.svg?raw';
import ph_mouse_right_click from '@phosphor-icons/core/assets/regular/mouse-right-click.svg?raw';
import ph_network from '@phosphor-icons/core/assets/regular/network.svg?raw';
import ph_note from '@phosphor-icons/core/assets/regular/note.svg?raw';
import ph_note_blank from '@phosphor-icons/core/assets/regular/note-blank.svg?raw';
import ph_note_pencil from '@phosphor-icons/core/assets/regular/note-pencil.svg?raw';
import ph_notebook from '@phosphor-icons/core/assets/regular/notebook.svg?raw';
import ph_notepad from '@phosphor-icons/core/assets/regular/notepad.svg?raw';
import ph_number_circle_one from '@phosphor-icons/core/assets/regular/number-circle-one.svg?raw';
import ph_oven from '@phosphor-icons/core/assets/regular/oven.svg?raw';
import ph_package from '@phosphor-icons/core/assets/regular/package.svg?raw';
import ph_paint_bucket from '@phosphor-icons/core/assets/regular/paint-bucket.svg?raw';
import ph_paint_roller from '@phosphor-icons/core/assets/regular/paint-roller.svg?raw';
import ph_palette from '@phosphor-icons/core/assets/regular/palette.svg?raw';
import ph_paper_plane_right from '@phosphor-icons/core/assets/regular/paper-plane-right.svg?raw';
import ph_paper_plane_tilt from '@phosphor-icons/core/assets/regular/paper-plane-tilt.svg?raw';
import ph_paperclip from '@phosphor-icons/core/assets/regular/paperclip.svg?raw';
import ph_paragraph from '@phosphor-icons/core/assets/regular/paragraph.svg?raw';
import ph_path from '@phosphor-icons/core/assets/regular/path.svg?raw';
import ph_pause_circle from '@phosphor-icons/core/assets/regular/pause-circle.svg?raw';
import ph_pen from '@phosphor-icons/core/assets/regular/pen.svg?raw';
import ph_pen_nib from '@phosphor-icons/core/assets/regular/pen-nib.svg?raw';
import ph_pencil_circle from '@phosphor-icons/core/assets/regular/pencil-circle.svg?raw';
import ph_pencil_line from '@phosphor-icons/core/assets/regular/pencil-line.svg?raw';
import ph_pencil_simple from '@phosphor-icons/core/assets/regular/pencil-simple.svg?raw';
import ph_pencil_simple_line from '@phosphor-icons/core/assets/regular/pencil-simple-line.svg?raw';
import ph_pencil_simple_slash from '@phosphor-icons/core/assets/regular/pencil-simple-slash.svg?raw';
import ph_pentagon from '@phosphor-icons/core/assets/regular/pentagon.svg?raw';
import ph_percent from '@phosphor-icons/core/assets/regular/percent.svg?raw';
import ph_phone from '@phosphor-icons/core/assets/regular/phone.svg?raw';
import ph_phone_call from '@phosphor-icons/core/assets/regular/phone-call.svg?raw';
import ph_picture_in_picture from '@phosphor-icons/core/assets/regular/picture-in-picture.svg?raw';
import ph_piggy_bank from '@phosphor-icons/core/assets/regular/piggy-bank.svg?raw';
import ph_pipe from '@phosphor-icons/core/assets/regular/pipe.svg?raw';
import ph_play from '@phosphor-icons/core/assets/regular/play.svg?raw';
import ph_play_circle from '@phosphor-icons/core/assets/regular/play-circle.svg?raw';
import ph_plug from '@phosphor-icons/core/assets/regular/plug.svg?raw';
import ph_plugs_connected from '@phosphor-icons/core/assets/regular/plugs-connected.svg?raw';
import ph_plus from '@phosphor-icons/core/assets/regular/plus.svg?raw';
import ph_plus_circle from '@phosphor-icons/core/assets/regular/plus-circle.svg?raw';
import ph_plus_square from '@phosphor-icons/core/assets/regular/plus-square.svg?raw';
import ph_polygon from '@phosphor-icons/core/assets/regular/polygon.svg?raw';
import ph_power from '@phosphor-icons/core/assets/regular/power.svg?raw';
import ph_presentation_chart from '@phosphor-icons/core/assets/regular/presentation-chart.svg?raw';
import ph_printer from '@phosphor-icons/core/assets/regular/printer.svg?raw';
import ph_prohibit from '@phosphor-icons/core/assets/regular/prohibit.svg?raw';
import ph_pulse from '@phosphor-icons/core/assets/regular/pulse.svg?raw';
import ph_push_pin from '@phosphor-icons/core/assets/regular/push-pin.svg?raw';
import ph_qr_code from '@phosphor-icons/core/assets/regular/qr-code.svg?raw';
import ph_question from '@phosphor-icons/core/assets/regular/question.svg?raw';
import ph_radio_button from '@phosphor-icons/core/assets/regular/radio-button.svg?raw';
import ph_receipt from '@phosphor-icons/core/assets/regular/receipt.svg?raw';
import ph_rectangle from '@phosphor-icons/core/assets/regular/rectangle.svg?raw';
import ph_robot from '@phosphor-icons/core/assets/regular/robot.svg?raw';
import ph_rocket from '@phosphor-icons/core/assets/regular/rocket.svg?raw';
import ph_rocket_launch from '@phosphor-icons/core/assets/regular/rocket-launch.svg?raw';
import ph_rows from '@phosphor-icons/core/assets/regular/rows.svg?raw';
import ph_rows_plus_bottom from '@phosphor-icons/core/assets/regular/rows-plus-bottom.svg?raw';
import ph_rows_plus_top from '@phosphor-icons/core/assets/regular/rows-plus-top.svg?raw';
import ph_ruler from '@phosphor-icons/core/assets/regular/ruler.svg?raw';
import ph_scales from '@phosphor-icons/core/assets/regular/scales.svg?raw';
import ph_scan from '@phosphor-icons/core/assets/regular/scan.svg?raw';
import ph_scissors from '@phosphor-icons/core/assets/regular/scissors.svg?raw';
import ph_screencast from '@phosphor-icons/core/assets/regular/screencast.svg?raw';
import ph_scribble from '@phosphor-icons/core/assets/regular/scribble.svg?raw';
import ph_seal_check from '@phosphor-icons/core/assets/regular/seal-check.svg?raw';
import ph_shapes from '@phosphor-icons/core/assets/regular/shapes.svg?raw';
import ph_share_network from '@phosphor-icons/core/assets/regular/share-network.svg?raw';
import ph_shield from '@phosphor-icons/core/assets/regular/shield.svg?raw';
import ph_shield_check from '@phosphor-icons/core/assets/regular/shield-check.svg?raw';
import ph_shield_warning from '@phosphor-icons/core/assets/regular/shield-warning.svg?raw';
import ph_shopping_cart from '@phosphor-icons/core/assets/regular/shopping-cart.svg?raw';
import ph_shovel from '@phosphor-icons/core/assets/regular/shovel.svg?raw';
import ph_shower from '@phosphor-icons/core/assets/regular/shower.svg?raw';
import ph_shuffle from '@phosphor-icons/core/assets/regular/shuffle.svg?raw';
import ph_sidebar from '@phosphor-icons/core/assets/regular/sidebar.svg?raw';
import ph_sidebar_simple from '@phosphor-icons/core/assets/regular/sidebar-simple.svg?raw';
import ph_sigma from '@phosphor-icons/core/assets/regular/sigma.svg?raw';
import ph_sign_in from '@phosphor-icons/core/assets/regular/sign-in.svg?raw';
import ph_sign_out from '@phosphor-icons/core/assets/regular/sign-out.svg?raw';
import ph_signature from '@phosphor-icons/core/assets/regular/signature.svg?raw';
import ph_siren from '@phosphor-icons/core/assets/regular/siren.svg?raw';
import ph_skip_back from '@phosphor-icons/core/assets/regular/skip-back.svg?raw';
import ph_skip_forward from '@phosphor-icons/core/assets/regular/skip-forward.svg?raw';
import ph_sliders from '@phosphor-icons/core/assets/regular/sliders.svg?raw';
import ph_sliders_horizontal from '@phosphor-icons/core/assets/regular/sliders-horizontal.svg?raw';
import ph_smiley from '@phosphor-icons/core/assets/regular/smiley.svg?raw';
import ph_solar_panel from '@phosphor-icons/core/assets/regular/solar-panel.svg?raw';
import ph_sparkle from '@phosphor-icons/core/assets/regular/sparkle.svg?raw';
import ph_speaker_high from '@phosphor-icons/core/assets/regular/speaker-high.svg?raw';
import ph_spinner_gap from '@phosphor-icons/core/assets/regular/spinner-gap.svg?raw';
import ph_spray_bottle from '@phosphor-icons/core/assets/regular/spray-bottle.svg?raw';
import ph_square from '@phosphor-icons/core/assets/regular/square.svg?raw';
import ph_squares_four from '@phosphor-icons/core/assets/regular/squares-four.svg?raw';
import ph_stack from '@phosphor-icons/core/assets/regular/stack.svg?raw';
import ph_stairs from '@phosphor-icons/core/assets/regular/stairs.svg?raw';
import ph_star from '@phosphor-icons/core/assets/regular/star.svg?raw';
import ph_star_half from '@phosphor-icons/core/assets/regular/star-half.svg?raw';
import ph_sun from '@phosphor-icons/core/assets/regular/sun.svg?raw';
import ph_swatches from '@phosphor-icons/core/assets/regular/swatches.svg?raw';
import ph_swimming_pool from '@phosphor-icons/core/assets/regular/swimming-pool.svg?raw';
import ph_t_shirt from '@phosphor-icons/core/assets/regular/t-shirt.svg?raw';
import ph_table from '@phosphor-icons/core/assets/regular/table.svg?raw';
import ph_tabs from '@phosphor-icons/core/assets/regular/tabs.svg?raw';
import ph_tag from '@phosphor-icons/core/assets/regular/tag.svg?raw';
import ph_target from '@phosphor-icons/core/assets/regular/target.svg?raw';
import ph_television from '@phosphor-icons/core/assets/regular/television.svg?raw';
import ph_text_aa from '@phosphor-icons/core/assets/regular/text-aa.svg?raw';
import ph_text_align_center from '@phosphor-icons/core/assets/regular/text-align-center.svg?raw';
import ph_text_align_left from '@phosphor-icons/core/assets/regular/text-align-left.svg?raw';
import ph_text_align_right from '@phosphor-icons/core/assets/regular/text-align-right.svg?raw';
import ph_text_b from '@phosphor-icons/core/assets/regular/text-b.svg?raw';
import ph_text_h from '@phosphor-icons/core/assets/regular/text-h.svg?raw';
import ph_text_italic from '@phosphor-icons/core/assets/regular/text-italic.svg?raw';
import ph_text_t from '@phosphor-icons/core/assets/regular/text-t.svg?raw';
import ph_text_underline from '@phosphor-icons/core/assets/regular/text-underline.svg?raw';
import ph_textbox from '@phosphor-icons/core/assets/regular/textbox.svg?raw';
import ph_thermometer from '@phosphor-icons/core/assets/regular/thermometer.svg?raw';
import ph_thermometer_cold from '@phosphor-icons/core/assets/regular/thermometer-cold.svg?raw';
import ph_thumbs_down from '@phosphor-icons/core/assets/regular/thumbs-down.svg?raw';
import ph_thumbs_up from '@phosphor-icons/core/assets/regular/thumbs-up.svg?raw';
import ph_timer from '@phosphor-icons/core/assets/regular/timer.svg?raw';
import ph_toggle_left from '@phosphor-icons/core/assets/regular/toggle-left.svg?raw';
import ph_toilet from '@phosphor-icons/core/assets/regular/toilet.svg?raw';
import ph_toolbox from '@phosphor-icons/core/assets/regular/toolbox.svg?raw';
import ph_translate from '@phosphor-icons/core/assets/regular/translate.svg?raw';
import ph_trash from '@phosphor-icons/core/assets/regular/trash.svg?raw';
import ph_tray from '@phosphor-icons/core/assets/regular/tray.svg?raw';
import ph_tray_arrow_down from '@phosphor-icons/core/assets/regular/tray-arrow-down.svg?raw';
import ph_tree_evergreen from '@phosphor-icons/core/assets/regular/tree-evergreen.svg?raw';
import ph_tree_structure from '@phosphor-icons/core/assets/regular/tree-structure.svg?raw';
import ph_trend_down from '@phosphor-icons/core/assets/regular/trend-down.svg?raw';
import ph_trend_up from '@phosphor-icons/core/assets/regular/trend-up.svg?raw';
import ph_triangle from '@phosphor-icons/core/assets/regular/triangle.svg?raw';
import ph_trophy from '@phosphor-icons/core/assets/regular/trophy.svg?raw';
import ph_truck from '@phosphor-icons/core/assets/regular/truck.svg?raw';
import ph_twitter_logo from '@phosphor-icons/core/assets/regular/twitter-logo.svg?raw';
import ph_umbrella from '@phosphor-icons/core/assets/regular/umbrella.svg?raw';
import ph_umbrella_simple from '@phosphor-icons/core/assets/regular/umbrella-simple.svg?raw';
import ph_upload_simple from '@phosphor-icons/core/assets/regular/upload-simple.svg?raw';
import ph_user from '@phosphor-icons/core/assets/regular/user.svg?raw';
import ph_user_check from '@phosphor-icons/core/assets/regular/user-check.svg?raw';
import ph_user_circle from '@phosphor-icons/core/assets/regular/user-circle.svg?raw';
import ph_user_focus from '@phosphor-icons/core/assets/regular/user-focus.svg?raw';
import ph_user_gear from '@phosphor-icons/core/assets/regular/user-gear.svg?raw';
import ph_user_minus from '@phosphor-icons/core/assets/regular/user-minus.svg?raw';
import ph_user_plus from '@phosphor-icons/core/assets/regular/user-plus.svg?raw';
import ph_users from '@phosphor-icons/core/assets/regular/users.svg?raw';
import ph_users_three from '@phosphor-icons/core/assets/regular/users-three.svg?raw';
import ph_virtual_reality from '@phosphor-icons/core/assets/regular/virtual-reality.svg?raw';
import ph_wall from '@phosphor-icons/core/assets/regular/wall.svg?raw';
import ph_wallet from '@phosphor-icons/core/assets/regular/wallet.svg?raw';
import ph_warning from '@phosphor-icons/core/assets/regular/warning.svg?raw';
import ph_warning_circle from '@phosphor-icons/core/assets/regular/warning-circle.svg?raw';
import ph_warning_octagon from '@phosphor-icons/core/assets/regular/warning-octagon.svg?raw';
import ph_washing_machine from '@phosphor-icons/core/assets/regular/washing-machine.svg?raw';
import ph_wifi_high from '@phosphor-icons/core/assets/regular/wifi-high.svg?raw';
import ph_wind from '@phosphor-icons/core/assets/regular/wind.svg?raw';
import ph_wrench from '@phosphor-icons/core/assets/regular/wrench.svg?raw';
import ph_x from '@phosphor-icons/core/assets/regular/x.svg?raw';
import ph_x_circle from '@phosphor-icons/core/assets/regular/x-circle.svg?raw';

export const PHOSPHOR_RAW: Record<string, string> = {
    'ambulance': ph_ambulance,
    'angle': ph_angle,
    'aperture': ph_aperture,
    'archive': ph_archive,
    'arrow-bend-up-left': ph_arrow_bend_up_left,
    'arrow-circle-right': ph_arrow_circle_right,
    'arrow-circle-up': ph_arrow_circle_up,
    'arrow-clockwise': ph_arrow_clockwise,
    'arrow-counter-clockwise': ph_arrow_counter_clockwise,
    'arrow-down': ph_arrow_down,
    'arrow-down-right': ph_arrow_down_right,
    'arrow-elbow-down-right': ph_arrow_elbow_down_right,
    'arrow-fat-up': ph_arrow_fat_up,
    'arrow-left': ph_arrow_left,
    'arrow-right': ph_arrow_right,
    'arrow-square-in': ph_arrow_square_in,
    'arrow-square-left': ph_arrow_square_left,
    'arrow-square-out': ph_arrow_square_out,
    'arrow-square-right': ph_arrow_square_right,
    'arrow-u-up-left': ph_arrow_u_up_left,
    'arrow-u-up-right': ph_arrow_u_up_right,
    'arrow-up': ph_arrow_up,
    'arrow-up-left': ph_arrow_up_left,
    'arrow-up-right': ph_arrow_up_right,
    'arrows-clockwise': ph_arrows_clockwise,
    'arrows-down-up': ph_arrows_down_up,
    'arrows-in': ph_arrows_in,
    'arrows-in-line-horizontal': ph_arrows_in_line_horizontal,
    'arrows-left-right': ph_arrows_left_right,
    'arrows-out': ph_arrows_out,
    'arrows-out-cardinal': ph_arrows_out_cardinal,
    'arrows-out-line-horizontal': ph_arrows_out_line_horizontal,
    'arrows-out-line-vertical': ph_arrows_out_line_vertical,
    'arrows-split': ph_arrows_split,
    'article': ph_article,
    'baby-carriage': ph_baby_carriage,
    'barricade': ph_barricade,
    'basket': ph_basket,
    'bathtub': ph_bathtub,
    'bed': ph_bed,
    'bell': ph_bell,
    'bell-ringing': ph_bell_ringing,
    'bell-slash': ph_bell_slash,
    'bezier-curve': ph_bezier_curve,
    'blueprint': ph_blueprint,
    'bluetooth': ph_bluetooth,
    'book': ph_book,
    'book-open': ph_book_open,
    'book-open-text': ph_book_open_text,
    'bookmark-simple': ph_bookmark_simple,
    'books': ph_books,
    'bounding-box': ph_bounding_box,
    'brackets-curly': ph_brackets_curly,
    'brain': ph_brain,
    'bridge': ph_bridge,
    'briefcase': ph_briefcase,
    'broom': ph_broom,
    'browser': ph_browser,
    'building': ph_building,
    'building-office': ph_building_office,
    'buildings': ph_buildings,
    'bulldozer': ph_bulldozer,
    'calculator': ph_calculator,
    'calendar': ph_calendar,
    'calendar-blank': ph_calendar_blank,
    'calendar-check': ph_calendar_check,
    'calendar-dot': ph_calendar_dot,
    'calendar-dots': ph_calendar_dots,
    'calendar-plus': ph_calendar_plus,
    'calendar-slash': ph_calendar_slash,
    'calendar-star': ph_calendar_star,
    'calendar-x': ph_calendar_x,
    'camera': ph_camera,
    'camera-plus': ph_camera_plus,
    'cards': ph_cards,
    'caret-circle-down': ph_caret_circle_down,
    'caret-double-left': ph_caret_double_left,
    'caret-double-right': ph_caret_double_right,
    'caret-down': ph_caret_down,
    'caret-left': ph_caret_left,
    'caret-line-left': ph_caret_line_left,
    'caret-line-right': ph_caret_line_right,
    'caret-right': ph_caret_right,
    'caret-up': ph_caret_up,
    'caret-up-down': ph_caret_up_down,
    'certificate': ph_certificate,
    'chart-bar': ph_chart_bar,
    'chart-bar-horizontal': ph_chart_bar_horizontal,
    'chart-line': ph_chart_line,
    'chart-line-down': ph_chart_line_down,
    'chart-line-up': ph_chart_line_up,
    'chart-pie': ph_chart_pie,
    'chart-scatter': ph_chart_scatter,
    'chat': ph_chat,
    'chat-circle': ph_chat_circle,
    'chat-circle-dots': ph_chat_circle_dots,
    'chat-circle-text': ph_chat_circle_text,
    'chat-dots': ph_chat_dots,
    'chat-teardrop': ph_chat_teardrop,
    'chat-text': ph_chat_text,
    'chats': ph_chats,
    'chats-circle': ph_chats_circle,
    'check': ph_check,
    'check-circle': ph_check_circle,
    'check-square': ph_check_square,
    'check-square-offset': ph_check_square_offset,
    'checkerboard': ph_checkerboard,
    'checks': ph_checks,
    'circle': ph_circle,
    'circle-dashed': ph_circle_dashed,
    'circle-half': ph_circle_half,
    'circle-notch': ph_circle_notch,
    'circles-three': ph_circles_three,
    'city': ph_city,
    'clipboard': ph_clipboard,
    'clipboard-text': ph_clipboard_text,
    'clock': ph_clock,
    'clock-clockwise': ph_clock_clockwise,
    'clock-countdown': ph_clock_countdown,
    'clock-counter-clockwise': ph_clock_counter_clockwise,
    'clock-user': ph_clock_user,
    'cloud': ph_cloud,
    'cloud-arrow-down': ph_cloud_arrow_down,
    'cloud-arrow-up': ph_cloud_arrow_up,
    'cloud-check': ph_cloud_check,
    'cloud-fog': ph_cloud_fog,
    'cloud-lightning': ph_cloud_lightning,
    'cloud-rain': ph_cloud_rain,
    'cloud-slash': ph_cloud_slash,
    'cloud-snow': ph_cloud_snow,
    'cloud-sun': ph_cloud_sun,
    'cloud-warning': ph_cloud_warning,
    'coat-hanger': ph_coat_hanger,
    'code': ph_code,
    'coins': ph_coins,
    'columns': ph_columns,
    'columns-plus-right': ph_columns_plus_right,
    'compass': ph_compass,
    'compass-tool': ph_compass_tool,
    'copy': ph_copy,
    'copy-simple': ph_copy_simple,
    'corners-in': ph_corners_in,
    'corners-out': ph_corners_out,
    'couch': ph_couch,
    'credit-card': ph_credit_card,
    'cross': ph_cross,
    'crown': ph_crown,
    'cube': ph_cube,
    'currency-dollar': ph_currency_dollar,
    'cursor': ph_cursor,
    'database': ph_database,
    'desk': ph_desk,
    'device-mobile': ph_device_mobile,
    'diamond': ph_diamond,
    'door': ph_door,
    'door-open': ph_door_open,
    'dots-nine': ph_dots_nine,
    'dots-six': ph_dots_six,
    'dots-six-vertical': ph_dots_six_vertical,
    'dots-three': ph_dots_three,
    'dots-three-vertical': ph_dots_three_vertical,
    'download-simple': ph_download_simple,
    'dresser': ph_dresser,
    'drop': ph_drop,
    'drop-half': ph_drop_half,
    'drop-slash': ph_drop_slash,
    'dropbox-logo': ph_dropbox_logo,
    'envelope-simple': ph_envelope_simple,
    'envelope-simple-open': ph_envelope_simple_open,
    'equals': ph_equals,
    'eraser': ph_eraser,
    'exclamation-mark': ph_exclamation_mark,
    'export': ph_export,
    'eye': ph_eye,
    'eye-slash': ph_eye_slash,
    'eyedropper': ph_eyedropper,
    'facebook-logo': ph_facebook_logo,
    'fan': ph_fan,
    'file': ph_file,
    'file-arrow-down': ph_file_arrow_down,
    'file-arrow-up': ph_file_arrow_up,
    'file-code': ph_file_code,
    'file-csv': ph_file_csv,
    'file-dashed': ph_file_dashed,
    'file-doc': ph_file_doc,
    'file-image': ph_file_image,
    'file-magnifying-glass': ph_file_magnifying_glass,
    'file-pdf': ph_file_pdf,
    'file-plus': ph_file_plus,
    'file-ppt': ph_file_ppt,
    'file-text': ph_file_text,
    'file-xls': ph_file_xls,
    'file-zip': ph_file_zip,
    'files': ph_files,
    'film-strip': ph_film_strip,
    'fire-extinguisher': ph_fire_extinguisher,
    'first-aid-kit': ph_first_aid_kit,
    'flag': ph_flag,
    'flag-checkered': ph_flag_checkered,
    'flame': ph_flame,
    'flask': ph_flask,
    'flip-horizontal': ph_flip_horizontal,
    'flip-vertical': ph_flip_vertical,
    'floppy-disk': ph_floppy_disk,
    'flower': ph_flower,
    'folder': ph_folder,
    'folder-open': ph_folder_open,
    'folder-plus': ph_folder_plus,
    'folder-simple-dashed': ph_folder_simple_dashed,
    'folders': ph_folders,
    'fork-knife': ph_fork_knife,
    'frame-corners': ph_frame_corners,
    'function': ph_function,
    'funnel': ph_funnel,
    'funnel-simple': ph_funnel_simple,
    'funnel-x': ph_funnel_x,
    'garage': ph_garage,
    'gauge': ph_gauge,
    'gear': ph_gear,
    'gift': ph_gift,
    'git-branch': ph_git_branch,
    'github-logo': ph_github_logo,
    'globe': ph_globe,
    'google-drive-logo': ph_google_drive_logo,
    'grid-four': ph_grid_four,
    'hammer': ph_hammer,
    'hand': ph_hand,
    'hand-coins': ph_hand_coins,
    'hand-heart': ph_hand_heart,
    'hand-swipe-left': ph_hand_swipe_left,
    'hand-tap': ph_hand_tap,
    'hard-hat': ph_hard_hat,
    'hash': ph_hash,
    'heart': ph_heart,
    'heart-half': ph_heart_half,
    'heartbeat': ph_heartbeat,
    'highlighter': ph_highlighter,
    'hourglass': ph_hourglass,
    'hourglass-medium': ph_hourglass_medium,
    'house': ph_house,
    'house-line': ph_house_line,
    'house-simple': ph_house_simple,
    'identification-badge': ph_identification_badge,
    'image': ph_image,
    'image-broken': ph_image_broken,
    'images': ph_images,
    'infinity': ph_infinity,
    'info': ph_info,
    'instagram-logo': ph_instagram_logo,
    'intersect-square': ph_intersect_square,
    'invoice': ph_invoice,
    'key': ph_key,
    'keyboard': ph_keyboard,
    'ladder': ph_ladder,
    'laptop': ph_laptop,
    'layout': ph_layout,
    'lifebuoy': ph_lifebuoy,
    'lightbulb': ph_lightbulb,
    'lightbulb-filament': ph_lightbulb_filament,
    'lightning': ph_lightning,
    'line-segment': ph_line_segment,
    'line-segments': ph_line_segments,
    'line-vertical': ph_line_vertical,
    'link': ph_link,
    'link-break': ph_link_break,
    'link-simple': ph_link_simple,
    'link-simple-break': ph_link_simple_break,
    'linkedin-logo': ph_linkedin_logo,
    'list': ph_list,
    'list-bullets': ph_list_bullets,
    'list-checks': ph_list_checks,
    'list-dashes': ph_list_dashes,
    'list-magnifying-glass': ph_list_magnifying_glass,
    'list-numbers': ph_list_numbers,
    'list-plus': ph_list_plus,
    'lock': ph_lock,
    'lock-open': ph_lock_open,
    'lock-simple': ph_lock_simple,
    'magic-wand': ph_magic_wand,
    'magnet': ph_magnet,
    'magnet-straight': ph_magnet_straight,
    'magnifying-glass': ph_magnifying_glass,
    'magnifying-glass-minus': ph_magnifying_glass_minus,
    'magnifying-glass-plus': ph_magnifying_glass_plus,
    'map-pin': ph_map_pin,
    'map-pin-area': ph_map_pin_area,
    'map-trifold': ph_map_trifold,
    'megaphone': ph_megaphone,
    'megaphone-simple': ph_megaphone_simple,
    'microphone': ph_microphone,
    'microphone-slash': ph_microphone_slash,
    'minus': ph_minus,
    'minus-circle': ph_minus_circle,
    'minus-square': ph_minus_square,
    'money': ph_money,
    'money-wavy': ph_money_wavy,
    'mouse-right-click': ph_mouse_right_click,
    'network': ph_network,
    'note': ph_note,
    'note-blank': ph_note_blank,
    'note-pencil': ph_note_pencil,
    'notebook': ph_notebook,
    'notepad': ph_notepad,
    'number-circle-one': ph_number_circle_one,
    'oven': ph_oven,
    'package': ph_package,
    'paint-bucket': ph_paint_bucket,
    'paint-roller': ph_paint_roller,
    'palette': ph_palette,
    'paper-plane-right': ph_paper_plane_right,
    'paper-plane-tilt': ph_paper_plane_tilt,
    'paperclip': ph_paperclip,
    'paragraph': ph_paragraph,
    'path': ph_path,
    'pause-circle': ph_pause_circle,
    'pen': ph_pen,
    'pen-nib': ph_pen_nib,
    'pencil-circle': ph_pencil_circle,
    'pencil-line': ph_pencil_line,
    'pencil-simple': ph_pencil_simple,
    'pencil-simple-line': ph_pencil_simple_line,
    'pencil-simple-slash': ph_pencil_simple_slash,
    'pentagon': ph_pentagon,
    'percent': ph_percent,
    'phone': ph_phone,
    'phone-call': ph_phone_call,
    'picture-in-picture': ph_picture_in_picture,
    'piggy-bank': ph_piggy_bank,
    'pipe': ph_pipe,
    'play': ph_play,
    'play-circle': ph_play_circle,
    'plug': ph_plug,
    'plugs-connected': ph_plugs_connected,
    'plus': ph_plus,
    'plus-circle': ph_plus_circle,
    'plus-square': ph_plus_square,
    'polygon': ph_polygon,
    'power': ph_power,
    'presentation-chart': ph_presentation_chart,
    'printer': ph_printer,
    'prohibit': ph_prohibit,
    'pulse': ph_pulse,
    'push-pin': ph_push_pin,
    'qr-code': ph_qr_code,
    'question': ph_question,
    'radio-button': ph_radio_button,
    'receipt': ph_receipt,
    'rectangle': ph_rectangle,
    'robot': ph_robot,
    'rocket': ph_rocket,
    'rocket-launch': ph_rocket_launch,
    'rows': ph_rows,
    'rows-plus-bottom': ph_rows_plus_bottom,
    'rows-plus-top': ph_rows_plus_top,
    'ruler': ph_ruler,
    'scales': ph_scales,
    'scan': ph_scan,
    'scissors': ph_scissors,
    'screencast': ph_screencast,
    'scribble': ph_scribble,
    'seal-check': ph_seal_check,
    'shapes': ph_shapes,
    'share-network': ph_share_network,
    'shield': ph_shield,
    'shield-check': ph_shield_check,
    'shield-warning': ph_shield_warning,
    'shopping-cart': ph_shopping_cart,
    'shovel': ph_shovel,
    'shower': ph_shower,
    'shuffle': ph_shuffle,
    'sidebar': ph_sidebar,
    'sidebar-simple': ph_sidebar_simple,
    'sigma': ph_sigma,
    'sign-in': ph_sign_in,
    'sign-out': ph_sign_out,
    'signature': ph_signature,
    'siren': ph_siren,
    'skip-back': ph_skip_back,
    'skip-forward': ph_skip_forward,
    'sliders': ph_sliders,
    'sliders-horizontal': ph_sliders_horizontal,
    'smiley': ph_smiley,
    'solar-panel': ph_solar_panel,
    'sparkle': ph_sparkle,
    'speaker-high': ph_speaker_high,
    'spinner-gap': ph_spinner_gap,
    'spray-bottle': ph_spray_bottle,
    'square': ph_square,
    'squares-four': ph_squares_four,
    'stack': ph_stack,
    'stairs': ph_stairs,
    'star': ph_star,
    'star-half': ph_star_half,
    'sun': ph_sun,
    'swatches': ph_swatches,
    'swimming-pool': ph_swimming_pool,
    't-shirt': ph_t_shirt,
    'table': ph_table,
    'tabs': ph_tabs,
    'tag': ph_tag,
    'target': ph_target,
    'television': ph_television,
    'text-aa': ph_text_aa,
    'text-align-center': ph_text_align_center,
    'text-align-left': ph_text_align_left,
    'text-align-right': ph_text_align_right,
    'text-b': ph_text_b,
    'text-h': ph_text_h,
    'text-italic': ph_text_italic,
    'text-t': ph_text_t,
    'text-underline': ph_text_underline,
    'textbox': ph_textbox,
    'thermometer': ph_thermometer,
    'thermometer-cold': ph_thermometer_cold,
    'thumbs-down': ph_thumbs_down,
    'thumbs-up': ph_thumbs_up,
    'timer': ph_timer,
    'toggle-left': ph_toggle_left,
    'toilet': ph_toilet,
    'toolbox': ph_toolbox,
    'translate': ph_translate,
    'trash': ph_trash,
    'tray': ph_tray,
    'tray-arrow-down': ph_tray_arrow_down,
    'tree-evergreen': ph_tree_evergreen,
    'tree-structure': ph_tree_structure,
    'trend-down': ph_trend_down,
    'trend-up': ph_trend_up,
    'triangle': ph_triangle,
    'trophy': ph_trophy,
    'truck': ph_truck,
    'twitter-logo': ph_twitter_logo,
    'umbrella': ph_umbrella,
    'umbrella-simple': ph_umbrella_simple,
    'upload-simple': ph_upload_simple,
    'user': ph_user,
    'user-check': ph_user_check,
    'user-circle': ph_user_circle,
    'user-focus': ph_user_focus,
    'user-gear': ph_user_gear,
    'user-minus': ph_user_minus,
    'user-plus': ph_user_plus,
    'users': ph_users,
    'users-three': ph_users_three,
    'virtual-reality': ph_virtual_reality,
    'wall': ph_wall,
    'wallet': ph_wallet,
    'warning': ph_warning,
    'warning-circle': ph_warning_circle,
    'warning-octagon': ph_warning_octagon,
    'washing-machine': ph_washing_machine,
    'wifi-high': ph_wifi_high,
    'wind': ph_wind,
    'wrench': ph_wrench,
    'x': ph_x,
    'x-circle': ph_x_circle
};
